module.exports = __webpack_public_path__ + "static/media/Caracol.77904bf9.svg";